import getBodySettings from '../../global/page-settings';
import formIndicators from './reporting/form-item-indicators';
import formFooter from './project-review/form-footer';

const { nameController, namePage } = getBodySettings('page');

export default function() {
    // if (nameController === 'projectreview' || namePage === 'certificationchecklist') {
        formFooter();
    // }
    if (namePage === 'reports') {
        formIndicators();
    }
}
